import React, { lazy } from "react";

const ProcessInsight = lazy(() => import("./process-insight"));
const RulesConfiguration = lazy(() => import("./rules-configuration"));
const AlertsConfiguration = lazy(() => import("./alerts-configuration"));
const StateConfiguration = lazy(() => import("./state-configuration"));
const ProportionalControllerTuning = lazy(() => import("./proportional-controller-tuning"));

const ControlsRoute = () => {
    const routes = [
        {
            key: "rules_configuration",
            path: "/controls_admin/rules_configuration",
            component: <RulesConfiguration />,
        },
        {
            key: "process_insight",
            path: "/controls_admin/process_insight",
            component: <ProcessInsight />,
        },
        {
            key: "state_action_matrix",
            path: "/controls_admin/state_action_matrix",
            component: <StateConfiguration />,
        },
        {
            key: "alerts_configuration",
            path: "/controls_admin/alerts_configuration",
            component: <AlertsConfiguration />,
        },
        {
            key: "proportional_controller_tuning",
            path: "/controls_admin/proportional_controller_tuning",
            component: <ProportionalControllerTuning />,
        },
    ];

    return routes;
};

export default ControlsRoute;
